// 产品系列卡片点击跳转
document.addEventListener('DOMContentLoaded', function() {
  const collectionCards = document.querySelectorAll('.collection-card');
  
  collectionCards.forEach(card => {
    card.addEventListener('click', function(e) {
      // 如果点击的不是按钮或其他交互元素
      if (!e.target.closest('button, a:not(.collection-card__link)')) {
        const link = this.querySelector('.collection-card__link');
        if (link && link.href) {
          window.location.href = link.href;
        }
      }
    });
  });
});
